<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">冻结时间配置</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="search()"
          class="btn-search"
          >{{ $t("app.buttons.search") }}</v-btn
        >
        <v-btn to="/M2500/New">{{
          $t("app.buttons.new")
        }}</v-btn>
        <v-btn
          @click="edit()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.edit") }}</v-btn
        >
        <v-btn
          @click="remove()"
          :disabled="selected.length !== 1"
          >{{ $t("app.buttons.remove") }}</v-btn
        >
        <v-flex md2 pl-2 sm2 xs2 v-if="isTestAdmin()">
          <date-picker label="模拟冻结日期" v-model="query.yearMonth"></date-picker>
        </v-flex>

       <v-btn v-if="isTestAdmin()"
          @click="triggerArchive()"
          class="btn-search"
          >触发冻结</v-btn
        >

        <v-btn v-if="isTestAdmin()"
          @click="triggerQuickReportArchive()"
          class="btn-search"
          >触发速报冻结</v-btn
        >

       
      
      </v-card-actions>
    </v-card>
    <v-card class="mt-2" >
      <v-card-actions>
        <v-btn @click="editApPaginationConfig()" :disabled="!canEditApPaginationConfig()">編集</v-btn>
        <v-btn @click="saveApPaginationConfig()" :disabled="!canSaveApPaginationConfig()">保存</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  :disabled="!canSaveApPaginationConfig()"
                  v-model="apPaginationConfig.pageSize"
                  label="AP分页大小"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
     
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>
            {{
              getArchiveTypeDesc(props.item.archiveType)
            }}
          </td>
          <td>
            {{ getArchiveDayDesc(props.item.archiveDay) }}
          </td>
         
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      apPaginationConfigMode:'display',
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      apPaginationConfig:{},
      query: {},
      headers: [
        {
          text: "冻结类型",
          value: "archiveType",
          sortable: false,
        },
        {
          text: "冻结日期",
          value: "archiveDay",
          sortable: false,
        },
       
      ],
    };
  },

  methods: {
    canEditApPaginationConfig(){
      return this.apPaginationConfigMode=='display'
    },
    canSaveApPaginationConfig(){
      return this.apPaginationConfigMode=='edit'
    },
    editApPaginationConfig(){
      this.apPaginationConfigMode='edit';
    },
    saveApPaginationConfig(){
      this.$http.post(`/ap-pagination-configs`,this.apPaginationConfig).then(res=>{
        this.apPaginationConfigMode='display';
        this.loadApPaginationConfig();
      })
    },
    
    isTestAdmin() {
      var t = "TangoTE" === this.$store.getters.user.code;
      return (
        t === true 
      );
    },
    triggerArchive(){
      this.$http
        .post(`/arap/archive-trigger?ymd=${this.query.yearMonth}`,null )
        .then((res) => {
          alert("冻结trigger 触发")
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    triggerQuickReportArchive(){
      this.$http
        .post(`/arap/archive-trigger/quick-report?ymd=${this.query.yearMonth}`,null )
        .then((res) => {
          alert("速报冻结trigger 触发")
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getArchiveTypeDesc(archiveType){
      if(archiveType=='AP_INTERNATIONAL_PHASE_ONE'){
        return "AP国际段第一次冻结";
      }
      if(archiveType=='AP_INTERNATIONAL_PHASE_TWO'){
        return "AP国际段第二次冻结";
      }
      if(archiveType=='AP_LOCAL'){
        return "AP国内端冻结";
      }
      if(archiveType=='AR'){
        return "AR冻结";
      }
    },
    getArchiveDayDesc(archiveDay){
      if(archiveDay=='MONTH_END'){
        return "月末";
      }
      return archiveDay;
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      };
    },
    search() {
      this.pagination.page = 1;
      this.load();
    },
    remove() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        this.$http
          .delete(`/archive-configs/${this.selected[0].id}`)
          .then(() => {
            this.load();
            this.$message("", this.$t("app.messages.removeSuccess"));
            this.selected = [];
          });
      });
    },
    load() {
      this.autoload = true;
      this.$storeParams();
      this.loading = true;
      this.$http
        .get("/archive-configs", this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1;
          this.pagination.rowsPerPage = res.data.size;
          this.pagination.totalItems = res.data.totalElements;
          this.results = res.data.content;
          this.loading = false;
          this.selected = [];
        })
        .catch(() => {
          this.loading = false;
        });

       
    },
    edit() {
      this.$router.push({
        path: "M2500/edit",
        query: {
          id: this.selected[0].id,
        },
      });
    },

    loadApPaginationConfig(){
      this.$http
        .get("/ap-pagination-configs", this.params())
          .then((res) => {
            this.apPaginationConfig = res.data || {};
          })
          .catch(() => {
            this.loading = false;
          });
    }
    
   
  },
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
  mounted() {
    this.$loadParams();
    this.loadApPaginationConfig();
  },
};
</script>
